/**
 * @generated SignedSource<<bd5468e6c14b3286aa60ccb68f42d769>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AreaOfImprovementPageQuery$variables = {
  projectPath: string;
  slug: string;
  teamPath: string;
};
export type AreaOfImprovementPageQuery$data = {
  readonly team: {
    readonly masterQuestionnaire: {
      readonly " $fragmentSpreads": FragmentRefs<"AreaOfImprovementTagSelect_questionnaire" | "useAreaOfImprovementTagSelectOptions_questionnaire">;
    } | null | undefined;
    readonly project: {
      readonly improvementBank: {
        readonly areaOfImprovement: {
          readonly activities: ReadonlyArray<{
            readonly slug: string;
            readonly " $fragmentSpreads": FragmentRefs<"EditImprovementActivityPage_activity" | "ImprovementActivityCard_activity">;
          } | null | undefined>;
          readonly id: string;
          readonly problemDescription: string | null | undefined;
          readonly summary: string;
          readonly tags: ReadonlyArray<{
            readonly __typename: "AreaOfImprovementIndicatorTag";
            readonly indicatorKey: string;
            readonly questionnaireId: string;
          } | {
            readonly __typename: "AreaOfImprovementQuestionTag";
            readonly questionId: string;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          }>;
          readonly " $fragmentSpreads": FragmentRefs<"AddImprovementActivityPage_areaOfImprovement" | "EditImprovementActivityPage_areaOfImprovement">;
        } | null | undefined;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"AddImprovementActivityPage_project" | "EditImprovementActivityPage_project">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"AddImprovementActivityPage_team" | "EditImprovementActivityPage_team">;
  } | null | undefined;
};
export type AreaOfImprovementPageQuery = {
  response: AreaOfImprovementPageQuery$data;
  variables: AreaOfImprovementPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectPath"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamPath"
},
v3 = [
  {
    "kind": "Variable",
    "name": "path",
    "variableName": "teamPath"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "projectPath",
    "variableName": "projectPath"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "problemDescription",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "tags",
  "plural": true,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "questionnaireId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "indicatorKey",
          "storageKey": null
        }
      ],
      "type": "AreaOfImprovementIndicatorTag",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "questionId",
          "storageKey": null
        }
      ],
      "type": "AreaOfImprovementQuestionTag",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectId",
      "storageKey": null
    }
  ],
  "type": "TeamMemberProjectRole",
  "abstractKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailAddress",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AreaOfImprovementPageQuery",
    "selections": [
      {
        "alias": "team",
        "args": (v3/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "teamByPath",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AddImprovementActivityPage_team"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EditImprovementActivityPage_team"
          },
          {
            "alias": "project",
            "args": (v4/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "projectByPath",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AddImprovementActivityPage_project"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EditImprovementActivityPage_project"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ImprovementBank",
                "kind": "LinkedField",
                "name": "improvementBank",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v5/*: any*/),
                    "concreteType": "AreaOfImprovement",
                    "kind": "LinkedField",
                    "name": "areaOfImprovement",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "AddImprovementActivityPage_areaOfImprovement"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "EditImprovementActivityPage_areaOfImprovement"
                      },
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImprovementActivity",
                        "kind": "LinkedField",
                        "name": "activities",
                        "plural": true,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ImprovementActivityCard_activity"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "EditImprovementActivityPage_activity"
                          },
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Questionnaire",
            "kind": "LinkedField",
            "name": "masterQuestionnaire",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useAreaOfImprovementTagSelectOptions_questionnaire"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AreaOfImprovementTagSelect_questionnaire"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "AreaOfImprovementPageQuery",
    "selections": [
      {
        "alias": "team",
        "args": (v3/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "teamByPath",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamMember",
            "kind": "LinkedField",
            "name": "members",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "roles",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "portfolioId",
                        "storageKey": null
                      }
                    ],
                    "type": "TeamMemberPortfolioRole",
                    "abstractKey": null
                  },
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "project",
            "args": (v4/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "projectByPath",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isProjectInterface"
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "portfolio",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "parent",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v6/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "parent",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "SubPortfolio",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "SubPortfolio",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamMember",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v17/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "roles",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ImprovementBank",
                "kind": "LinkedField",
                "name": "improvementBank",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v5/*: any*/),
                    "concreteType": "AreaOfImprovement",
                    "kind": "LinkedField",
                    "name": "areaOfImprovement",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImprovementActivity",
                        "kind": "LinkedField",
                        "name": "activities",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "completedBy",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "completedOn",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ImprovementActivityPerformanceReview",
                            "kind": "LinkedField",
                            "name": "performanceReview",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "successRating",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "comment",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "goal",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "responsiblePerson",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deadline",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Questionnaire",
            "kind": "LinkedField",
            "name": "masterQuestionnaire",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": "questionnaireId",
                "args": null,
                "kind": "ScalarField",
                "name": "originalId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Indicator",
                "kind": "LinkedField",
                "name": "indicators",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  {
                    "alias": "questionIds",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "originalQuestionIds",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Question",
                "kind": "LinkedField",
                "name": "questions",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": "questionId",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "originalId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fullForm",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shortForm",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isMeta",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSurveyMeta",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "99393e33e7e1a6c54185e9eecd07ec66",
    "id": null,
    "metadata": {},
    "name": "AreaOfImprovementPageQuery",
    "operationKind": "query",
    "text": "query AreaOfImprovementPageQuery(\n  $projectPath: String!\n  $teamPath: String!\n  $slug: String!\n) {\n  team: teamByPath(path: $teamPath) {\n    ...AddImprovementActivityPage_team\n    ...EditImprovementActivityPage_team\n    project: projectByPath(projectPath: $projectPath) {\n      __typename\n      ...AddImprovementActivityPage_project\n      ...EditImprovementActivityPage_project\n      improvementBank {\n        areaOfImprovement(slug: $slug) {\n          ...AddImprovementActivityPage_areaOfImprovement\n          ...EditImprovementActivityPage_areaOfImprovement\n          id\n          summary\n          problemDescription\n          tags {\n            __typename\n            ... on AreaOfImprovementIndicatorTag {\n              questionnaireId\n              indicatorKey\n            }\n            ... on AreaOfImprovementQuestionTag {\n              questionId\n            }\n          }\n          activities {\n            ...ImprovementActivityCard_activity\n            ...EditImprovementActivityPage_activity\n            slug\n            id\n          }\n        }\n        id\n      }\n      id\n    }\n    masterQuestionnaire {\n      ...useAreaOfImprovementTagSelectOptions_questionnaire\n      ...AreaOfImprovementTagSelect_questionnaire\n      id\n    }\n    id\n  }\n}\n\nfragment AddImprovementActivityPage_areaOfImprovement on AreaOfImprovement {\n  id\n  summary\n  problemDescription\n}\n\nfragment AddImprovementActivityPage_project on ProjectInterface {\n  __isProjectInterface: __typename\n  ...useProjectImprovementsTeamMembers_project\n  ...ProjectTeamMemberSelect_project\n}\n\nfragment AddImprovementActivityPage_team on Team {\n  ...useProjectImprovementsTeamMembers_team\n}\n\nfragment AddProjectTeamMemberForm_project on ProjectInterface {\n  __isProjectInterface: __typename\n  id\n}\n\nfragment AddProjectTeamMemberForm_team on Team {\n  id\n  members {\n    user {\n      id\n      emailAddress\n      firstName\n      lastName\n    }\n    roles {\n      __typename\n      ... on TeamMemberProjectRole {\n        projectId\n      }\n    }\n    id\n  }\n}\n\nfragment AreaOfImprovementTagSelect_questionnaire on Questionnaire {\n  ...useAreaOfImprovementTagSelectOptions_questionnaire\n  id\n  questionnaireId: originalId\n  indicators {\n    key\n    name\n    questionIds: originalQuestionIds\n    id\n  }\n  questions {\n    id\n    questionId: originalId\n    fullForm\n    shortForm\n    isMeta\n    isSurveyMeta\n  }\n}\n\nfragment DeleteImprovementActivityForm_activity on ImprovementActivity {\n  id\n  summary\n  completedOn\n}\n\nfragment EditImprovementActivityPage_activity on ImprovementActivity {\n  ...MarkImprovementActivityAsCompletedForm_activity\n  id\n  slug\n  summary\n  description\n  goal\n  startDate\n  deadline\n  responsiblePerson {\n    id\n  }\n  completedOn\n  performanceReview {\n    successRating\n    comment\n  }\n}\n\nfragment EditImprovementActivityPage_areaOfImprovement on AreaOfImprovement {\n  id\n  summary\n  problemDescription\n}\n\nfragment EditImprovementActivityPage_project on ProjectInterface {\n  __isProjectInterface: __typename\n  ...useProjectImprovementsTeamMembers_project\n  ...ProjectTeamMemberSelect_project\n}\n\nfragment EditImprovementActivityPage_team on Team {\n  ...useProjectImprovementsTeamMembers_team\n}\n\nfragment ImprovementActivityCard_activity on ImprovementActivity {\n  ...MarkImprovementActivityAsCompletedForm_activity\n  ...DeleteImprovementActivityForm_activity\n  id\n  slug\n  summary\n  description\n  goal\n  responsiblePerson {\n    fullName\n    id\n  }\n  startDate\n  deadline\n  completedOn\n  performanceReview {\n    successRating\n    comment\n  }\n}\n\nfragment MarkImprovementActivityAsCompletedForm_activity on ImprovementActivity {\n  id\n  summary\n  completedBy {\n    id\n  }\n  completedOn\n  performanceReview {\n    successRating\n    comment\n  }\n}\n\nfragment ProjectTeamMemberSelect_project on ProjectInterface {\n  __isProjectInterface: __typename\n  ...AddProjectTeamMemberForm_project\n  team {\n    ...AddProjectTeamMemberForm_team\n    id\n  }\n}\n\nfragment useAreaOfImprovementTagSelectOptions_questionnaire on Questionnaire {\n  id\n  questionnaireId: originalId\n  indicators {\n    key\n    name\n    questionIds: originalQuestionIds\n    id\n  }\n  questions {\n    id\n    questionId: originalId\n    fullForm\n    shortForm\n    isMeta\n    isSurveyMeta\n  }\n}\n\nfragment useProjectImprovementsTeamMembers_project on ProjectInterface {\n  __isProjectInterface: __typename\n  id\n  portfolio {\n    __typename\n    id\n    ... on SubPortfolio {\n      parent {\n        __typename\n        id\n        ... on SubPortfolio {\n          parent {\n            __typename\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment useProjectImprovementsTeamMembers_team on Team {\n  id\n  members {\n    roles {\n      name\n      __typename\n      ... on TeamMemberTeamRole {\n        __typename\n      }\n      ... on TeamMemberPortfolioRole {\n        portfolioId\n      }\n      ... on TeamMemberProjectRole {\n        projectId\n      }\n    }\n    user {\n      id\n      fullName\n      firstName\n      lastName\n      emailAddress\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "abce4f49686768de72552af246471cf1";

export default node;
